import { Component } from 'nospa';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import anime from 'animejs';

import clickOut from '@/helpers/clickOut';
import mediaBreakpoints from '@/helpers/mediaBreakpoints';

export default class CatalogFilter extends Component {
  onInit() {
    this.onClickButton = this.onClickButton.bind(this);
    this.onClickClose = this.onClickClose.bind(this);
    this.onClickOut = this.onClickOut.bind(this);
    this.onBreakpointChange = this.onBreakpointChange.bind(this);

    this.buttonRef = this.$getRef('button');
    this.closeRef = this.$getRef('close');
    this.paneRef = this.$getRef('pane');
    this.overlayRef = this.$getRef('overlay');

    this.setEvents();
    mediaBreakpoints.subscribe(this.onBreakpointChange);
  }

  setEvents(add = true) {
    const action = add ? 'addEventListener' : 'removeEventListener';

    if (this.buttonRef) {
      this.buttonRef.el[action]('click', this.onClickButton);
    }

    if (this.closeRef) {
      this.closeRef.el[action]('click', this.onClickClose);
    }
  }

  onClickButton(e) {
    e.preventDefault();
    this.openMobile();
  }

  onClickClose(e) {
    e.preventDefault();
    this.closeMobile();
  }

  onClickOut() {
    this.closeMobile();
  }

  openMobile(immediate) {
    if (this.isMobileOpened) return;
    this.isMobileOpened = true;

    clickOut.bind(this.paneRef.el, this.onClickOut);
    disableBodyScroll(this.paneRef.el, {
      reserveScrollBarGap: true,
    });

    const tl = anime.timeline({
      begin: () => {
        if (this.paneRef) {
          this.paneRef.el.style.display = 'block';
        }

        if (this.overlayRef) {
          this.overlayRef.el.style.display = 'block';
        }
      },
    });

    if (this.paneRef) {
      anime.remove(this.paneRef);
      tl.add({
        targets: this.paneRef.el,
        translateX: ['-100%', 0],
        easing: 'easeOutCubic',
        duration: immediate ? 0 : 300,
      });
    }

    if (this.overlayRef) {
      anime.remove(this.overlayRef);
      tl.add({
        targets: this.overlayRef.el,
        opacity: 1,
        easing: 'linear',
        duration: immediate ? 0 : 200,
      }, '-=300');
    }
  }

  closeMobile(immediate) {
    if (!this.isMobileOpened) return;
    this.isMobileOpened = false;

    clickOut.unbind(this.paneRef.el, this.onClickOut);
    enableBodyScroll(this.paneRef.el);

    const tl = anime.timeline({
      complete: () => {
        if (this.paneRef) {
          this.paneRef.el.style.transform = '';
          this.paneRef.el.style.display = '';
        }

        if (this.overlayRef) {
          this.overlayRef.el.style.display = '';
        }
      },
    });

    if (this.paneRef) {
      anime.remove(this.paneRef);
      tl.add({
        targets: this.paneRef.el,
        translateX: '-100%',
        easing: 'easeInCubic',
        duration: immediate ? 0 : 300,
      });
    }

    if (this.overlayRef) {
      anime.remove(this.overlayRef);
      tl.add({
        targets: this.overlayRef.el,
        opacity: 0,
        easing: 'linear',
        duration: immediate ? 0 : 200,
      }, '-=300');
    }
  }

  onBreakpointChange() {
    if (this.isMobileOpened && mediaBreakpoints.isUp(mediaBreakpoints.breakpoints.XL)) {
      this.closeMobile(true);
    }
  }

  onDestroy() {
    this.setEvents(false);
    this.closeMobile(true);
    mediaBreakpoints.unsubscribe(this.onBreakpointChange);
  }
}
